import html2canvas from 'html2canvas';

/**
 * Capture a DOM element as an image and share it
 * @param {HTMLElement} element - The DOM element to capture
 * @param {Object} options - { filename, title, text }
 */
export async function captureAndShare(element, options = {}) {
  const { filename = 'aura-share.png', title = 'My Aura ✨', text = 'Look at what my AI companion Aura created for me! ✨' } = options;
  
  try {
    // Capture element as canvas
    const canvas = await html2canvas(element, {
      backgroundColor: null,
      scale: 2, // Higher quality
      useCORS: true,
      logging: false,
      allowTaint: true,
    });
    
    // Convert to blob
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    
    // Try Web Share API first
    if (navigator.share && navigator.canShare) {
      const file = new File([blob], filename, { type: 'image/png' });
      if (navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({
            title,
            text,
            files: [file]
          });
          return { success: true, method: 'share' };
        } catch (e) {
          if (e.name === 'AbortError') return { success: false, cancelled: true };
        }
      }
    }
    
    // Fallback: Download
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return { success: true, method: 'download' };
  } catch (error) {
    console.error('Share error:', error);
    return { success: false, error };
  }
}
